<template>
  <div class="callme_total_wrap hidden-xs-only">
    <div class="title">
      <el-row :gutter="100"  type="flex" align="middle">
        <el-col :span="8">
          <el-image 
                style="width: 100%; height: auto;overflow: revert; margin: 0 auto"
                :src="src">
            </el-image>
        </el-col>  
        <el-col 
          :span="3"
          class="col_item" 
          v-for="(item, index) in titleList"
          :key="index">
          <div style="color:#fff">{{item.title}}</div>
        </el-col>
      </el-row>
    </div>
    <div class="content">
      <el-row :gutter="100" >
        <el-col :span="8">
            <div class="left" style="display:flex;justify-content:center; align-items: center">
              <div style="color:#fff" >
                <div >邮编：550081</div>
                <div >前台咨询热线：0851-87982219</div>
                <div >商家服务中心：0851-82202617</div>
                <div >联系邮箱：3173906443@qq.com</div>
              </div>
              <el-image 
                  style="width: 80px; height: 80px;overflow: revert; margin: 0 auto"
                  :src="code">
              </el-image>
            </div>
        </el-col>
        <el-col 
          :span="3"  
          class="col_item">
          <div style="color:#ffffffb8" class="tab_col">
            <!-- <div @click="handleToRouter('/production/contact')">关于我们</div> -->
            <div @click="goToSection('/production/contact', 'company-intro')">企业简介</div>
            <div @click="goToSection('/production/contact', 'company-qualification')">公司资质</div>
          </div>
        </el-col> 
        <!-- <el-col 
          :span="2.5"
          class="col_item">
          <div style="color:#ffffffb8" class="tab_col">
            <div >业务领域</div>
          </div>
        </el-col>   -->
        <el-col 
          :span="3"
          class="col_item">
          <div style="color:#ffffffb8" class="tab_col">
            <div @click="goToSection('/fournav/1', 'realtime-news')">实时动态</div>
            <div @click="goToSection('/fournav/1', 'news-center')">通知公告</div>
          </div>
        </el-col> 
        <el-col 
          :span="3"
          class="col_item">
          <div style="color:#ffffffb8" class="tab_col">
            <div @click="goToSection('/product/service', 'expert-system')">专家系统</div>
            <div @click="goToSection('/product/service', 'info-assistant')">资讯助手</div>
            <div @click="goToSection('/product/service', 'other-products')">其它产品</div>
          </div>
        </el-col> 
        <el-col 
          :span="3"
          class="col_item">
          <div style="color:#ffffffb8" class="tab_col">
            <div @click="handleToRouter('/GovernmentProcurementCase')">政采案列</div>
          </div>
        </el-col>
        <el-col 
          :span="3"
          class="col_item">
          <div style="color:#ffffffb8" class="tab_col">
            <div @click="goToSection('/fivenav/1', 'message-board')">留言板</div>
            <div @click="goToSection('/fivenav/1', 'contact-us')">联系我们</div>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex">
        <a style="color:#fff;" href="https://beian.miit.gov.cn">备案号：黔ICP备2025052801号-1</a>
      </el-row>
    </div>  
  </div>
</template>

<script>
export default {
  data() {
    return {
      src: require('@/assets/img/cellme/logo.gif'),
      code: require('@/assets/img/cellme/code.jpg'),
      titleList:[
        {
          title: '关于我们',
        },
        {
          title: '最新动态',
        },
        {
          title: '产品服务',
        },
        {
          title: '政采案列',
        },
        {
          title: '联系我们',
        }
      ],
      activeIndex: '1',
      showCity: 0,
    }
  },
  methods: {
    // 跳转到页面内的指定区域
    goToSection(path, sectionId) {
      if (this.$route.path !== path) {
        // 如果不在目标页面，先跳转页面，然后在页面加载后滚动
        this.$router.push(path).then(() => {
          this.$nextTick(() => {
            this.scrollToSection(sectionId);
          });
        });
      } else {
        // 如果已经在目标页面，直接滚动
        this.scrollToSection(sectionId);
      }
    },
    
    // 滚动到指定区域
    scrollToSection(sectionId) {
      this.$nextTick(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    },
    handleSelect(index) {
      this.showCity = parseInt(index) - 1
    },
    handleToRouter(url) {
      this.$router.replace(url)
    },
  },
}
</script>

<style lang="scss" scoped>
.callme_total_wrap {
  width: 100%;
  // margin-top: 80px;
  background: #CB5141;
  padding-bottom: 50px;
  .title{ 
    width: 70%;
    margin: 0 auto;
    padding: 70px 0 10px;
    border-bottom: 1px solid #A81F27;
    .col_item{
      padding:5px 2% !important;
    }
  }
  .content{
    width: 70%;
    margin: 10px auto;
    // padding: 50px 10px;
    .left{
      padding: 20px 0;
      border-right: 1px solid #A81F27;
    }
    .col_item{
      padding:5px 2% !important;
      .tab_col{
        div{
          line-height: 24px;
        }
      }
    }
  }
  .callme_top_wrap {
    width: 100%;
    height: 300px;
    // background: url('../../assets/img/call.a455486.png') 0 0 no-repeat;
    // background-size: 100% 100%;
  }
  .callme_bottom_wrap {
    width: 70%;
    margin: 0 auto;
    
    color: #fff;
    padding-top: 70px;
    .bottom_container {
      width: 70%;
      margin: 0 auto;
      display: flex;
      padding-bottom: 60px;
      border-bottom: solid #363636 2px;
      .items_wrap {
        margin-right: 100px;
        .item_tit {
          font-size: 22px;
        }
        .item_options {
          display: flex;
          flex-direction: column;
          width: 120px;
          span {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 16px;
            margin-top: 35px;
            cursor: pointer;
            &:hover {
              font-weight: bold;
            }
          }
          .el_menu_demo {
            border: none;
            background: none;
            margin-top: 10px;
            width: 300PX;
            .el_menu_item {
              &:hover {
                font-weight: bold;
              }
            }
          }
          .massage_show {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 15px;
            width: 300PX;
            height: 80px;
            p {
              margin-top: 30px;
            }
          }
          img {
            width: 100%;
            margin-top: 20px;
          }
        }
      }
    }
    .navigate_wrap {
      width: 70%;
      margin: 0 auto;
      margin-top: 40px;
      padding-bottom: 15px;
      // word-break: keep-all;
      // word-wrap: break-word;
      display: flex;
      flex-wrap: wrap;
      a {
        color: hsla(0, 0%, 100%, 0.5);
        font-size: 16px;
        margin-right: 33px;
        text-decoration: none;
      }
      span {
        color: #fff;
        padding-right: 30px;
        font-size: 18px;
        margin-right: 0;
      }
      p {
        font-size: 16px;
        color: #4e5557;
      }
    }
  }
}
</style>